import { Image, Link, Text, View } from '@react-pdf/renderer';
import { S3_URL } from 'constants';
import { checkObjHasValues, convertToPng } from 'utils';

const Social = ({ styles, data = [], headerTitle, randomString }: any) => {
	return (
		<View style={styles.mainBox}>
			<Text style={styles.heading}>{headerTitle}</Text>

			<View style={styles.mainBoxInner}>
				{data?.map((res: any) => {
					if (checkObjHasValues(res)) {
						return (
							<View key={`social-${res?.slug}`} style={styles.detailBox}>
								{res?.image && (
									<View>
										<Image style={styles.detailIcon} src={`${S3_URL}${res?.image}`} />
									</View>
								)}
								<View>
									<Text style={styles.detailSubText}>
										<Link style={styles.detailText} src={res?.socialLink}>
											{res?.title}
										</Link>
									</Text>
								</View>
							</View>
						);
					}
				})}
			</View>
		</View>
	);
};

export default Social;
